import { createContext, useContext } from 'react';
import type { LocalDb } from './localDb';

export const DbContext = createContext<LocalDb | null>(null);

export function useDb(): LocalDb {
  const db = useContext(DbContext);
  if (!db) throw new Error('useDb must be used inside DataProvider');
  return db;
}
